import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import '@/styles/global.css';

// Amplify outputs are generated by `ampx generate outputs` and gitignored.
// In CI they are generated before the build step (see amplify.yml).
try {
  const outputs = await import('../amplify_outputs.json');
  Amplify.configure(outputs.default);
} catch {
  console.warn('amplify_outputs.json not found — run `npm run sandbox` to generate it.');
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,  // 5 minutes
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
